import React, { useState } from "react";
import { CPInput } from "../CPInput";
import { EstimateBottomSheet } from "../estimate/EstimateBottomSheet";
import "./WorkspaceNameSheet.css";

/**
 * Name entry used by Estimate locations and Project locations/features.
 * Persistence stays with the caller. Project locations/features also pass
 * `withTargetCompletion` for the optional internal Target Completion date.
 */
export function WorkspaceNameSheet({
  title,
  fieldLabel,
  placeholder,
  initialName = "",
  withTargetCompletion = false,
  initialTargetCompletion = "",
  primaryLabel,
  onClose,
  onSubmit,
}) {
  const [name, setName] = useState(initialName);
  const [targetCompletion, setTargetCompletion] = useState(initialTargetCompletion || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  async function handleSave() {
    const trimmed = name.trim();
    if (!trimmed) {
      setError(`Enter a ${fieldLabel.toLowerCase()}.`);
      return;
    }

    setSaving(true);
    setError("");
    try {
      if (withTargetCompletion) {
        // Only send the date when it changed, so a plain rename never touches it.
        const changed = targetCompletion !== (initialTargetCompletion || "");
        await onSubmit(trimmed, changed ? { targetCompletionDate: targetCompletion } : {});
      } else {
        await onSubmit(trimmed);
      }
      onClose?.();
    } catch (err) {
      setError(err.message || "Unable to save.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <EstimateBottomSheet
      title={title}
      onClose={onClose}
      onPrimary={handleSave}
      primaryLabel={primaryLabel || title}
      primaryBusy={saving}
      error={error}
    >
      <CPInput
        label={fieldLabel}
        value={name}
        onChange={setName}
        placeholder={placeholder}
        required
      />
      {withTargetCompletion ? (
        <div className="ws-target-field">
          <CPInput
            label="Target Completion"
            type="date"
            value={targetCompletion}
            onChange={setTargetCompletion}
          />
          <div className="ws-target-help">Optional. Internal planning date, not shown to your client.</div>
        </div>
      ) : null}
    </EstimateBottomSheet>
  );
}
